<div class="addContainer" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="modalHeader" cdkDragHandle>
    <div class="editRowModal">
      <div class="modalHeader clearfix">
        <div class="modal-about">
          {{dialogTitle}}
        </div>
      </div>
    </div>
    <button mat-icon-button (click)="dialogRef.close()" class="modal-close-button" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div mat-dialog-content>
    <form class="register-form m-4" [formGroup]="alertaForm" (keydown.enter)="$event.preventDefault()">
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Fecha</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="fecha">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-2">
          <mat-checkbox formControlName="activo" class="checkbox">
            Alerta activa
          </mat-checkbox>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Descripcion</mat-label>
            <input matInput required formControlName="descripcion">
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>URL</mat-label>
            <input matInput required formControlName="url">
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Asociado</mat-label>
            <input matInput formControlName="asociado" [matAutocomplete]="auto" autocomplete="off">
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
              <mat-option *ngFor="let option of filteredOptions | async"
                [value]="transformarNombre(option.dni, option.nombre, option.apellido1, option.apellido2)">
                {{ transformarNombre(option.dni, option.nombre, option.apellido1, option.apellido2) }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>
      
      @if(errorMessage){
      <div class="error-message col-lg-8 col-md-6">
        {{ errorMessage }}
      </div>
      }

      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
          <div class="example-button-row">
            <button mat-raised-button color="warn" (click)="onNoClick()" tabindex="-1">Cancelar</button>
            <button mat-raised-button color="primary" (click)="guardar()">Guardar</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>